import React, { useEffect } from 'react';
import './skills.css';
import django from '../../assets/django.png';
import js from '../../assets/js.png';
import py from '../../assets/py.png';
import git from '../../assets/git.png';
import github from '../../assets/github.png';
import nuxt from '../../assets/nuxt.png';
import wordpress from '../../assets/wordpress.png';
import react from '../../assets/react.png';
import angular from '../../assets/angular.png';
import tail from '../../assets/tail.png';
import boot from '../../assets/boot.png';
import vs from '../../assets/vs.png';
import elementor from '../../assets/elementor.png';
import figma from '../../assets/figma.png';
import winscp from '../../assets/winscp.png';
import webflow from '../../assets/webflow.png';
import AOS from 'aos'; // Import AOS
import Marquee from "react-fast-marquee";

const Skills = () => {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <section id='skills'>
      <div className='container mt-5'>
        <div className='text-center'>
          <h1 data-aos="fade-up">What <span className="introText">I do</span></h1>
          <p data-aos="fade-up">I build websites, design user-friendly interfaces, and help businesses improve their online presence. My work focuses on creating effective, engaging digital solutions that make an impact. I use a range of technologies and tools to achieve this, including</p>
        </div>
        {/* <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-2'>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-2 mt-2'>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
        </div>
        <div className='col-lg-12 d-flex justify-content-evenly flex-wrap flex-md-nowrap gap-2 mt-2'>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
          <div className='skill-bar p-4' data-aos="fade-up">
            <div className='d-flex align-items-center gap-3'>
              <div className=''><img src={django} alt='' className='django' width="auto" /></div>
              <div className=''>
                <h5>Django</h5>
                <p className='m-0'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quaerat</p>
              </div>
            </div>
          </div>
        </div> */}
        <div className='mt-5' data-aos="fade-up">
        <h5 className='text-center mb-5'><span className="introText">Technologies</span></h5>
        <Marquee>
        <img src={django} alt='' className='django' width="auto" />
        <img src={js} alt='' className='js' width="auto" />
        <img src={py} alt='' className='py' width="auto" />
        <img src={git} alt='' className='git' width="auto" />
        <img src={wordpress} alt='' className='wordpress' width="auto" />
        <img src={nuxt} alt='' className='nuxt' width="auto" />
        {/* <img src={deluge} alt='' className='deluge' width="auto" /> */}
        {/* <img src={next} alt='' className='crm' height={`100px`} width="auto" /> */}
        <img src={react} alt='' className='react' width="auto" />
        <img src={angular} alt='' className='angular' width="auto" />
        <img src={tail} alt='' className='tail' width="auto" />
        <img src={boot} alt='' className='boot' width="auto" />
        </Marquee>
        </div>
        <div className='mt-5' data-aos="fade-up">
        <h5 className='text-center mb-5'><span className="introText">Tools</span></h5>
        <Marquee direction="right">
        <img src={vs} alt='' className='vs' width="auto" />
        <img src={elementor} alt='' className='elementor' width="auto" />
        <img src={figma} alt='' className='figma' width="auto" />
        <img src={winscp} alt='' className='winscp' width="auto" />
        <img src={github} alt='' className='github' width="auto" />
        <img src={webflow} alt='' className='webflow' width="auto" />
        </Marquee>
        </div>
      </div>
    </section>
  );
}

export default Skills;
